export class PayserviceRequestError extends Error {
    public code: number;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args: any) {
        super(...args);
        this.name = 'PayserviceRequestError';
        this.code = args[1];
    }
}
